import React, { useEffect, useRef } from "react";
import Lenis from "lenis";
import Navbar from "../components/site/Navbar";
import Hero from "../components/site/Hero";
import About from "../components/site/About";
import Manifesto from "../components/site/Manifesto";
import MarqueeStrip from "../components/site/MarqueeStrip";
import Services from "../components/site/Services";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";

export default function MarketingSite() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      smoothWheel: true,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (lenisRef.current) lenisRef.current.scrollTo(el, { offset: -68 });
    else el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="bg-[#060A14] min-h-screen">
      <div className="noise-overlay" />
      <Navbar onScrollTo={scrollTo} />
      <main>
        <Hero onScrollTo={scrollTo} />
        <About />
        <Manifesto />
        <MarqueeStrip />
        <Services onScrollTo={scrollTo} />
        <Contact />
      </main>
      <Footer onScrollTo={scrollTo} />
    </div>
  );
}
